/* Available stock minus quantities already in the cart. */
if (!window.LifestyleInventory) {
  window.LifestyleInventory = {
    cart: null,
    pending: null,
    refresh() {
      if (this.pending) return this.pending;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.pending = fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error('Cart could not be loaded');
          return response.json();
        })
        .then(cart => {
          this.cart = cart;
          document.querySelectorAll('product-quantity[data-js-product-quantity]').forEach(selector => selector.syncInventory());
          return cart;
        })
        .catch(() => null)
        .finally(() => { this.pending = null; });
      return this.pending;
    },
    quantity(variantId, fallback) {
      if (!this.cart) return Number(fallback) || 0;
      return this.cart.items.reduce((total, item) => total +
        (String(item.variant_id) === String(variantId) ? item.quantity : 0), 0);
    }
  };
  ['krown:cart:add', 'krown:cart:update', 'krown:cart:error', 'cart-updated'].forEach(name => {
    document.addEventListener(name, () => window.LifestyleInventory.refresh(), true);
  });
  window.addEventListener('pageshow', () => window.LifestyleInventory.refresh());
  window.addEventListener('focus', () => window.LifestyleInventory.refresh());
}

if (!customElements.get('product-quantity')) {
  class ProductQuantity extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.input = this.querySelector('.qty-selector');
        this.minus = this.querySelector('.qty-minus');
        this.plus = this.querySelector('.qty-plus');
        if (!this.input || !this.minus || !this.plus) return;
        this.initialized = true;
        this.minus.type = this.plus.type = 'button';
        const normalize = () => this.clamp(true);
        this.input.addEventListener('input', normalize);
        this.input.addEventListener('change', normalize);
        this.minus.addEventListener('click', event => this.step(event, -1));
        this.plus.addEventListener('click', event => this.step(event, 1));
      }
      this.syncInventory();
      if (this.hasAttribute('data-js-product-quantity')) window.LifestyleInventory.refresh();
    }

    limits() {
      const min = Number(this.input.min || 0);
      const max = this.input.hasAttribute('max') ? Number(this.input.max) : Infinity;
      return { min, max };
    }

    clamp(normalize = false) {
      if (!this.input) return;
      const { min, max } = this.limits();
      let value = parseInt(this.input.value, 10);
      if (!Number.isFinite(value)) value = min;
      value = Math.min(max, Math.max(min, value));
      if (normalize || max < min || Number(this.input.value) > max) this.input.value = value;
      this.minus.disabled = max < min || value <= min;
      this.plus.disabled = max < min || value >= max;
      this.minus.classList.toggle('disabled', this.minus.disabled);
      this.plus.classList.toggle('disabled', this.plus.disabled);
    }

    step(event, direction) {
      event.preventDefault();
      this.clamp(true);
      const { min, max } = this.limits();
      if (max < min) return;
      this.input.value = Math.min(max, Math.max(min, Number(this.input.value) + direction));
      this.clamp(true);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncInventory() {
      if (!this.input) return;
      if (this.hasAttribute('data-js-product-quantity')) {
        if (this.dataset.lifestyleStock !== '') {
          const cartQty = window.LifestyleInventory.quantity(this.dataset.lifestyleVariant, this.dataset.lifestyleCartQty);
          this.input.max = Math.max(0, Number(this.dataset.lifestyleStock) - cartQty);
        } else {
          this.input.removeAttribute('max');
        }
        const exhausted = this.input.hasAttribute('max') && Number(this.input.max) === 0;
        const form = this.closest('form');
        const button = form && form.querySelector('[data-js-product-add-to-cart]');
        if (button) {
          if (exhausted && !button.disabled) {
            button.disabled = true;
            button.dataset.lifestyleStockDisabled = 'true';
          } else if (!exhausted && button.dataset.lifestyleStockDisabled) {
            button.disabled = false;
            delete button.dataset.lifestyleStockDisabled;
          }
        }
        const message = this.querySelector('.lifestyle-stock-message');
        if (message) message.textContent = exhausted ?
          (Number(this.dataset.lifestyleStock) > 0 ? 'Die verfügbare Menge liegt bereits in deinem Warenkorb.' : 'Dieser Artikel ist ausverkauft.') : '';
      }
      this.clamp(true);
    }

    updateInventoryFrom(source) {
      this.dataset.lifestyleVariant = source.dataset.lifestyleVariant;
      this.dataset.lifestyleStock = source.dataset.lifestyleStock;
      this.dataset.lifestyleCartQty = source.dataset.lifestyleCartQty;
      this.syncInventory();
    }

    async prepareAddition() {
      const variantId = this.dataset.lifestyleVariant;
      await window.LifestyleInventory.refresh();
      if (variantId !== this.dataset.lifestyleVariant) return false;
      this.syncInventory();
      return Number(this.input.value) >= 1 && this.input.checkValidity();
    }
  }
  customElements.define('product-quantity', ProductQuantity);
}
